export const theme = {
    primaryColor: "#cecece",
    padding: "5vw"
};
